import { LDContext } from 'launchdarkly-js-client-sdk';
import React from 'react';

export type FeatureFlagsFlagValue = boolean;

export interface FeatureFlagsContextType {
  getFlag(flagKey: string, defaultValue?: FeatureFlagsFlagValue): FeatureFlagsFlagValue;
}

export type FeatureFlagsUserContext = LDContext;

export const FeatureFlagsContext = React.createContext<FeatureFlagsContextType | undefined>(
  undefined,
);
